module.exports = __webpack_public_path__ + "Lato-BlackItalic.d775ecb88ca3765bcf76.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-BlackItalic.eot
// module id = ../../../../../src/assets/fonts/Lato-BlackItalic.eot
// module chunks = styles